import LoaderOverlay from '@payaca/components/loaderOverlay/LoaderOverlay';

const SplashPage = () => {
  return <LoaderOverlay />;
};

export default SplashPage;
